import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export function Banner({ children, className, as, ...rest }) {
    const Component = as ?? "div";
    return (_jsx(Component, { className: classNames("cvr-banner", className), ...rest, children: children }));
}
